import type { RouteRecordRaw } from 'vue-router';

export const teachersRoute: RouteRecordRaw = {
  path: '/teachers',
  name: 'Teachers',
  component: () => import('./pages/TeachersPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:teachers:list'),
  },
};

export const teacherDetailRoute: RouteRecordRaw = {
  path: '/teachers/:id',
  name: 'TeacherDetail',
  component: () => import('./pages/TeacherPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:teachers:get'),
  },
};
